import { RegionData } from '../data/region/Region';
import { IPoint2d } from '../math/IPoint2d';
import { EEntityType } from '../types';
import { RegionTextInfo, TextInfoModel } from './2d/textInfo';
import BaseEntity from './BaseEntity';

interface IRegionTextInfoEntityParams {
  data: RegionData;
  name: string;
  visible: boolean;
}

export class RegionTextInfoEntity extends BaseEntity<EEntityType.TextInfo> {
  private _data: RegionData;
  private _label: RegionTextInfo;
  protected override _model2d: TextInfoModel;

  constructor(params: IRegionTextInfoEntityParams) {
    super({ type: EEntityType.TextInfo, id: params.data.id });
    this._data = params.data;
    this._label = new RegionTextInfo(params);
    this._model2d = new TextInfoModel({
      nameEl: this._label.nameEl,
      areaEl: this._label.areaEl,
      intersectable: false
    });
  }

  public getData() {
    return this._data;
  }

  public setVisible(visible: boolean) {
    this._model2d.setVisible(visible);
    this._label.setVisible(visible);
  }

  public override update(params: IRegionTextInfoEntityParams) {
    this._data = params.data;
    this._label.update(params);
    this._model2d.update();
  }

  public updateInfoEnable(enable: boolean) {
    this._label.updateInfoEnable(enable);
  }

  public resetFocus() {
    this._label.resetFocus();
  }

  public updatePosition() {
    this._label.updatePosition();
  }

  public setPositionOffset(offset?: IPoint2d) {
    return this._label.setPositionOffset(offset);
  }

  public getLabelRect() {
    return this._label.getBoundingClientRect();
  }

  override dispose(): void {
    super.dispose();
    this._label.dispose();
  }
}
